import React from "react";
import { NineCellLoading } from 'react-loadingg';

export default class ExpiredWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isWorking: false
        };
    }

    render() {

        return (
            <div style={backView}>
                <div style={mainView}>
                    { this.state.isWorking ? <NineCellLoading /> : (
                        <>
                            <img alt="" style={{ width: '20%', marginTop: '20px' }} src={ require('../images/sad_icon.png') } />
                            <p style={{ textAlign: 'center', width: '100%', marginTop: '20px', fontSize: 30, fontFamily: 'Teko', fontWeight: 'bold' }}>La tua prova gratuita di Hdemia è scaduta.</p>
                            <p style={{ textAlign: 'center', width: '80%', marginLeft: '10%', marginTop: '-15px', marginBottom: '15px', fontSize: 14, fontFamily: 'Open Sans' }}>Se il prodotto ti è piaciuto, se hai domande sulle possibili personalizzazioni o se anche solo vuoi saperne di più, contattaci!</p>
                            
                            <div style={{textAlign: 'center', marginTop: 30}}>
                                <div className="btn btn-primary" onClick={() => window.location.href = "mailto:info@appius.it"}>Contattaci</div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const backView = {
    width: '100%', 
    height: '100%', 
    display: 'block',
    position: 'absolute', 
    top: 0, 
    bottom: 0, 
    left: '5%', 
    right: 0,
    margin: 0,
}

const mainView = {
    width: '60%', 
    position: 'abolsute',
    marginLeft: '20%', 
    marginTop: '15%', 
    paddingBottom: '20px',
    backgroundColor: 'white', 
    borderRadius: '10px', 
    textAlign: 'center',
    boxShadow: '0px 2px 10px darkgrey',
}